
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoginComponent } from './pages/login/login.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { DeleteAccountComponent } from './pages/delete-account/delete-account.component';
import { DriverPayoutCompleteComponent } from './pages/driver-payout/driver-payout-complete.component';
import { DriverPayoutRefreshComponent } from './pages/driver-payout/driver-payout-refresh.component';
import { PreloadSelectedModulesList } from './services/preload_selected_modules_list';
// import { AuthGuard } from './guards/auth-guard.service';

const routes: Routes = [

  // place: canActivate: [AuthGuard] when connecting full app

  // { path: '', component: HomeComponent },
  {
    path: 'registration',
    loadChildren: './pages/registration/registration.module#RegistrationModule'
  },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'delete-account', component: DeleteAccountComponent },
  { path: 'driver-payout/complete', component: DriverPayoutCompleteComponent },
  { path: 'driver-payout/refresh', component: DriverPayoutRefreshComponent },

  {
    path: 'password',
    loadChildren: './pages/password/password.module#PasswordModule',
  },
  {
    path: 'merchant',
    loadChildren:
      './pages/pages.module#PagesModule'
  },

  {
    path: '',
    redirectTo: 'merchant',
    pathMatch: 'full'
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabled' })],  //initialNavigation: 'enabled' for removing flick
  exports: [RouterModule],
})
export class AppRoutingModule {
}
